import { render, staticRenderFns } from "./PetsTable.vue?vue&type=template&id=58d37d52"
import script from "./PetsTable.vue?vue&type=script&lang=js"
export * from "./PetsTable.vue?vue&type=script&lang=js"
import style0 from "./PetsTable.vue?vue&type=style&index=0&id=58d37d52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports